export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length >= 1) {
        const cookie = parts.pop().split(';').shift();
        return decodeURIComponent(cookie);
    }
}